var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.6001C0 8.36135 2.24375 10.6001 5 10.6001C7.76125 10.6001 10 8.35635 10 5.6001C10 2.83885 7.75625 0.600098 5 0.600098C2.23875 0.600098 0 2.84385 0 5.6001ZM1.25 5.6001C1.25 3.53322 2.92875 1.8501 5 1.8501C7.06687 1.8501 8.75 3.52885 8.75 5.6001C8.75 7.66697 7.07125 9.3501 5 9.3501C2.93313 9.3501 1.25 7.67135 1.25 5.6001ZM7.36125 4.5551L6.4775 3.67135L4.2675 5.88135L3.38375 4.9976L2.5 5.88135L4.2675 7.64885L6.25625 5.6601L7.36125 4.5551Z",
    fill: "#3D961F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.74f8de216deee129dfe7346cfc7b3fb6.svg";
export { ForwardRef as ReactComponent };